import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class ListRecordsService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
  ) { }

  listRecords(sectionId: string, userId: string, count : number, recordType : string, activeUsersOnly : boolean) {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    headers = headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    //
    let params = new HttpParams();

    if (count != null){
      params = params.set("count", count.toString());
    }

    if (recordType != null){
      params = params.set("recordType", recordType);
    }

    if (activeUsersOnly != null){
      params = params.set("activeUsersOnly", activeUsersOnly.toString());
    }

    if (userId === '' || typeof userId === 'undefined') {
      return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/records`, { headers: headers, params: params });
    } else {
      return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/records/${userId}`, { headers: headers, params: params });
    }
  }

}
